import { connect } from "react-redux";
import AddDemand from "./addDemand";
import { getLocations } from "../../../redux/actions/newService/locations.action";
import { getRoamingPartnerList } from "../../../redux/actions/newService/roamingPartnerList.action";
import { getServices } from "../../../redux/actions/newService/customerService.action";
import {getContriesList} from "../../../redux/actions/newService/serviceCountries.action";
import { SubmitRequst } from "../../../redux/actions/newService/submitServiceRequest.actions";
import { getServicesList } from "../../../redux/actions/newService/servicesList.actions";
import { openAlertPopup } from "../../../redux/actions/Alert/alert.action";
import { showErrorPopup } from "../../../redux/actions/customErrorPopup/customerrorpopup.action";
import { setServiceActiveTab } from "../../../redux/actions/newService/service.actions";
import { getServiceDetail } from "../../../redux/actions/newService/serviceDetail.actions";
import { SubmitUpdateRequst } from "../../../redux/actions/newService/updateServiceRequest.action";
import { getLiveServices, getLiveServicesForAmendDropDown } from "../../../redux/actions/liveServies/liveServices.action";
import { getCustomers } from "../../../redux/actions/newService/customers.action";

const mapStateToProps = (state) => {
  return {
    countries: state.newService.serviceCountriesList.data,
    locations: state.newService.locations.locations.locations,
    myRights: state.myRights.myRights,
    services: state.newService.services.services.services,
    isLoading: state.newService.services.loading,
    roamingPartnerName: state.newService.roamingPartnersList.data.data,
    organizations:state.newService.customers.customers.customers,
    serviceActiveTab:state.newService.service.serviceActiveTab,
    servicesDetail: state.newService.serviceDetail.serviceDetail,
    pops:state.liveServices.locationsOnNewDemandForm,
    liveServicesData:state.liveServices.liveServicedataOnNewDemandForm,
    amendServiceInitialValue:state.newService.service.initialValue,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLocations: () => {
      return dispatch(getLocations())
    },
    getRoamingPartnerList: () => {
      return dispatch(getRoamingPartnerList())
    },
    getServices: ()=>{
        return dispatch(getServices())
    },
    getContriesList: () => {
      return dispatch(getContriesList())
    },
    getServicesList: (status = '', searchKey = '',next=null)=>{
        return dispatch(getServicesList(status, searchKey,next))
    },
    getLiveServices: (cp_name,searchKey, filter,customer="",serviceType="",status="") => {
      return dispatch(getLiveServicesForAmendDropDown(cp_name,searchKey, filter,customer,serviceType,status))
  },
    submitRequest: (payload) => {
        return dispatch(SubmitRequst(payload))
    }, 
   showErrorPopup: (errorHeader,errormessage,isnote) => {
        return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
    },
    openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
    },
    setServiceActiveTab: (tab) => {
        return dispatch(setServiceActiveTab(tab))
    },
    getServiceDetail: (requestId) => {
      return dispatch(getServiceDetail(requestId))
    },
    SubmitUpdateRequst: (payload,id) => {
      return dispatch(SubmitUpdateRequst(payload,id))
    },
    getCustomers: () => {
      return dispatch(getCustomers())
    },
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(AddDemand);